<template>
  <PbsWelcome :animate="false" />
</template>
<script lang="ts" setup>
import PbsWelcome from '@/components/PbsWelcome.vue';
</script>
